// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
'use strict'
import { PFixField } from './PFixField.js'
var PFixLongArrayField = function (fieldId, buffer)
{
    this.Value = []
    PFixField.call(this, fieldId, buffer)
}

PFixLongArrayField.prototype = Object.create(PFixField.prototype)

PFixLongArrayField.prototype.ReadValue = function (buffer)
{
    let len = buffer.ReadInt32()
    let array = new Array(len)
    for (let i = 0; i < len; i++)
        array[i] = buffer.ReadInt64()

    this.Value = array
}

PFixLongArrayField.prototype.Write = function (buffer)
{
    let array = this.Value

    buffer.WriteShort(this.FieldId)
    buffer.WriteInt32(array.length)

    for (let i = 0, len = array.length; i < len; i++)
        buffer.WriteInt64(array[i])
}

export { PFixLongArrayField }